import { useSnackbar } from 'notistack';
import React, { useState } from 'react'
import { logOut } from '../../shared/_services/auth.services';
import Notifications from '../Notifications';
import { Link, useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal"
import BookAppointmentModal from '../AppointmentBooking';

function DashboardHeaderWithNoData() {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const [notificationPopupShow, setNotificationPopupShow] = useState(false);
    const [confirmLogoutShow, setConfirmLogoutShow] = useState(false);
    const [bookAppointmentModalState, setBookAppointmentModalState] = useState(false);
    const confirmLogoutClose = () => setConfirmLogoutShow();
    const openConfirmLogoutShow = () => {
        setConfirmLogoutShow(true);
    };

    const handleLogout = async () => {
      // logOut clears the stored session itself, whatever the server answered,
      // so this always navigates. Gating the clear on a 200 is what made logout
      // unusable: the request had the wrong shape for SEC-115 (#72), so the
      // branch never ran and the only feedback was an error toast. Even with the
      // right shape a 15-minute access token can expire in an open tab, and a
      // logout that refuses to work because the server said 401 is a worse
      // outcome than an orphaned refresh token nobody holds a copy of.
      const data = await logOut();

      if (data?.status !== 200) {
        enqueueSnackbar("Signed out on this device, but the server could not end the session.", {
          variant: "warning",
          anchorOrigin: { horizontal: "right", vertical: "top" },
        });
      }

      navigate("/login");
    }

    const handleNotificationCloseFn = (state) => {
        setNotificationPopupShow(state)
    }

    const handleNotificationsClick = () => {
        setNotificationPopupShow(true);
    };


    return (
        <>
            <div className="dashboard-header">
                <div className="d-flex justify-content-end">
                    {JSON.parse(localStorage.getItem("currentUser"))?.user?.data?.userType === 'client' && <button type="submit" className="as-btn-primary" onClick={() => setBookAppointmentModalState(true)}>
                        Book an Appointment
                    </button>}
                    {bookAppointmentModalState && <BookAppointmentModal onClose={() => setBookAppointmentModalState(false)} />}
                    <div className="circle-button" onClick={handleNotificationsClick}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 19V10C6 8.4087 6.63214 6.88258 7.75736 5.75736C8.88258 4.63214 10.4087 4 12 4C13.5913 4 15.1174 4.63214 16.2426 5.75736C17.3679 6.88258 18 8.4087 18 10V19M6 19H18M6 19H4M18 19H20M11 22H13" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M12 4C12.5523 4 13 3.55228 13 3C13 2.44772 12.5523 2 12 2C11.4477 2 11 2.44772 11 3C11 3.55228 11.4477 4 12 4Z" stroke="black" strokeWidth="2" />
                        </svg>
                    </div>
                    <Notifications onClose={handleNotificationCloseFn} showModal={notificationPopupShow} />
                    <div className="circle-button" onClick={openConfirmLogoutShow}>
                        <svg
                            width="27"
                            height="26"
                            viewBox="0 0 27 26"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M23.4298 19.4453H21.3703C21.2297 19.4453 21.0978 19.5068 21.0099 19.6152C20.8048 19.8643 20.5851 20.1045 20.3537 20.333C19.4071 21.2806 18.2858 22.0357 17.0519 22.5566C15.7736 23.0966 14.3996 23.3736 13.0119 23.3711C11.6086 23.3711 10.2492 23.0957 8.97184 22.5566C7.73793 22.0357 6.61667 21.2806 5.67008 20.333C4.7218 19.3886 3.96566 18.2694 3.44352 17.0371C2.90153 15.7598 2.62907 14.4033 2.62907 13C2.62907 11.5967 2.90446 10.2402 3.44352 8.96289C3.96501 7.72949 4.71501 6.61914 5.67008 5.66699C6.62516 4.71484 7.73551 3.96484 8.97184 3.44336C10.2492 2.9043 11.6086 2.6289 13.0119 2.6289C14.4152 2.6289 15.7746 2.90137 17.0519 3.44336C18.2882 3.96484 19.3986 4.71484 20.3537 5.66699C20.5851 5.89844 20.8019 6.13867 21.0099 6.38476C21.0978 6.49316 21.2326 6.55469 21.3703 6.55469H23.4298C23.6144 6.55469 23.7287 6.34961 23.6261 6.19433C21.3791 2.70215 17.4474 0.390624 12.9797 0.402342C5.96012 0.41992 0.332195 6.11816 0.402507 13.1289C0.47282 20.0283 6.09196 25.5977 13.0119 25.5977C17.4679 25.5977 21.382 23.2891 23.6261 19.8057C23.7257 19.6504 23.6144 19.4453 23.4298 19.4453ZM26.0343 12.8154L21.8771 9.53418C21.7218 9.41113 21.4963 9.52246 21.4963 9.71875V11.9453H12.297C12.1681 11.9453 12.0627 12.0508 12.0627 12.1797V13.8203C12.0627 13.9492 12.1681 14.0547 12.297 14.0547H21.4963V16.2812C21.4963 16.4775 21.7248 16.5889 21.8771 16.4658L26.0343 13.1846C26.0624 13.1626 26.085 13.1346 26.1006 13.1027C26.1162 13.0707 26.1243 13.0356 26.1243 13C26.1243 12.9644 26.1162 12.9293 26.1006 12.8973C26.085 12.8654 26.0624 12.8374 26.0343 12.8154Z"
                                fill="#1A1D43"
                            />
                        </svg>
                    </div>
                </div>
            </div>

            {/* confirm logout popup */}
            <Modal
                size="md"
                className="confirmLogoutPopup customMiniPopup"
                show={confirmLogoutShow}
                onHide={confirmLogoutClose}
                aria-labelledby="confirmLogoutPopupLabel"
                backdrop="static"
                keyboard={false}
                centered
            >
                <div className="modal-body">
                    <div className="d-flex justify-content-between">
                        <h4 className="mt-3">  </h4>
                        <Link className="close-popup-btn" onClick={confirmLogoutClose}>
                            <i className="fa fa-times"></i>
                        </Link>
                    </div>
                    <h4 className="mt-3 mb-3 text-center ">You are attempting to logout of Astra.</h4>
                    <h4 className="text-center">Are you sure?</h4>
                    <div className="text-center mt-4 mb-3">
                        <button className="as-btn-primary w-75" onClick={handleLogout}>Logout</button>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default DashboardHeaderWithNoData
